export default __webpack_public_path__ + "f6d9cb91d25f3842d31dad8783b9ddc0.png";